import { render } from "./HomeLayout.vue?vue&type=template&id=4f7fd108&scoped=true&ts=true"
import script from "./HomeLayout.vue?vue&type=script&lang=ts"
export * from "./HomeLayout.vue?vue&type=script&lang=ts"

import "./HomeLayout.vue?vue&type=style&index=0&id=4f7fd108&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7fd108"]])

export default __exports__